module.exports = __webpack_public_path__ + "static/unsplash-709ddb67f7fd41b3d14a05a2d39fd528.png";